import { exportFileFormat } from '../../../utils/ExportPemFileUtil'
import interceptedAxios from '../../../utils/interceptedAxios'

export async function downloadregularKekService (
  label: string,
  onSuccess: (exportFile: any) => any,
  onFailure: (errorMessage: string) => any
): Promise<void> {
  const url = `/app-config-service/api/v1/crypto/download/import-kek/{label}?label=${label}`
  try {
    const response = await interceptedAxios.get(url, { responseType: 'blob' })
    exportFileFormat(response, label)
    onSuccess(response)
  } catch (error: any) {
    onFailure(error.message)
  }
}
